/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Checkbox,
  Button,
  Input,
  InputNumber,
  DatePicker,
  message,
  Form,
} from 'antd';
import QRCode from 'qrcode.react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import anchorme from 'anchorme';
import { Redirect } from 'react-router';
import axios from 'axios';
import {
  reserveProductToUserAction,
  isUserAlreadyOrderedAction,
} from '../../data/modules/products/products.actions';
import { FlexDivCenter, Text } from '../../components/Typography/Typography';
import 'moment/locale/he';
import UseMedia from '../../customHooks/UseMedia';
import { getWeboConfig, isProductHasAgreement } from '../../utils';

export default ({ activeProduct = {}, setIsFinished }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [deservedForTheProduct, setDeservedForTheProduct] = useState(true);
  const [checked, setChecked] = useState(!isProductHasAgreement(activeProduct));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { activeUser } = useSelector((state) => state.auth);

  function disabledDate(current) {
    // Can not select days before today and today
    return (
      (current && current < moment().endOf('day')) ||
      current > moment().add(14, 'days')
    );
  }

  useEffect(() => {
    setLoading(true);
    dispatch(isUserAlreadyOrderedAction(activeProduct.id))
      .then((res) => {
        setDeservedForTheProduct(!get(res, 'data.alreadyOrdered'));
        setLoading(false);
      })
      .catch(() => {
        setDeservedForTheProduct(false);
        setLoading(false);
      });
  }, []);
  function isButtonDisabled() {
    return !checked || !deservedForTheProduct || loading;
  }

  function onReserveProduct() {
    form.validateFields().then(async (values) => {
      setLoading(true);
      const cloned = { ...values };
      const shouldNotPay = activeUser.membershipStatus === 'MEMBER' && activeProduct.discountPrice === 0;
      if (activeProduct.price && getWeboConfig('ENABLE_PAYMENTS') && !shouldNotPay) {
        const { dynamicPaymentUrl } = await axios
          .post('/payments/v1/start', {
            productId: activeProduct.id,
          })
          .then((res) => res.data);

        // Add a <a> to use to download an image file
        const openPaymentLink = document.createElement('a');
        openPaymentLink.id = 'link';
        window.document.body.appendChild(openPaymentLink);

        // Thanks https://stackoverflow.com/a/44487883
        const link = document.getElementById('link');
        link.setAttribute('href', dynamicPaymentUrl);
        link.click();
      } else {
        dispatch(
          reserveProductToUserAction({
            productId: activeProduct.id,
            userId: activeUser.id,
            answers: cloned,
            type: activeProduct.type,
          })
        ).then((res) => {
          setLoading(false);
          setIsFinished(res.approvalToken);
          message.success({
            content: t('assign_product_success'),
            style: {
              marginTop: '10vh',
              fontSize: 16,
            },
          });
        });
      }
    });
  }

  return !activeProduct.displayInStore ? (
    <Redirect path="/" />
  ) : !deservedForTheProduct ? (
    <FlexDivCenter>
      <Text>
        <span
          dangerouslySetInnerHTML={{
            __html: t('you_cannot_order_service', {
              office_address: getWeboConfig('OFFICE_ADDRESS'),
            }),
          }}
        />
      </Text>
    </FlexDivCenter>
  ) : (
    <Form
      style={{ marginTop: 30 }}
      form={form}
      name="normal_login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onReserveProduct}
    >
      {/* {!activeProduct.usePromo && (
        <Form.Item
          label={t('when_to_take')}
          name="willRentAt"
          rules={[
            {
              required: true,
              message: t('required', { field: t('when_to_take') }),
            },
          ]}
        >
          <DatePicker
            disabledDate={disabledDate}
            size="large"
            format="DD-MM-YYYY"
            locale={newlocale}
            style={{ zIndex: 999 }}
          />
        </Form.Item>
      )} */}
      {isProductHasAgreement(activeProduct) && (
        <Form.Item name="is_accepted">
          <FlexDivCenter style={{ maxWidth: 350 }}>
            <Text
              dangerouslySetInnerHTML={{
                __html: anchorme({
                  input: activeProduct?.agreement?.replace('\n', '<br/>') || '',
                  options: {
                    // any link will have the attribute "class='link'"
                    // and will be downloaded
                    attributes(string) {
                      const attributes = {
                        target: '_blank',
                      };
                      return attributes;
                    },
                  },
                }),
              }}
              align="right"
              size="small"
            >
              {/* {activeProduct.agreement} */}
            </Text>
          </FlexDivCenter>
          <Checkbox
            onChange={(e) => setChecked(e.target.checked)}
            style={{ fontSize: 20 }}
            max={7}
            min={1}
            placeholder="2"
          >
            {t('i_have_read')}
          </Checkbox>
        </Form.Item>
      )}
      <FlexDivCenter>
        <Form.Item>
          <Button
            htmlType="submit"
            disabled={isButtonDisabled()}
            style={{
              margin: 15,
              color: isButtonDisabled() ? '' : 'white',
              width: 150,
              background: isButtonDisabled() ? '' : '#1D3E7E',
            }}
            loading={loading}
            type="primary"
          >
            {t(activeProduct.price ? 'buy' : 'reserve')}
          </Button>
        </Form.Item>
      </FlexDivCenter>
    </Form>
  );
};
